var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-attendance-mobile-list-component" }, [
    _c("div", { staticClass: "room-attendance-mobile-list-wrapper" }, [
      _c(
        "ul",
        { staticClass: "room-attendance-mobile-list" },
        _vm._l(_vm.attendanceList, function (attendance, i) {
          return _c(
            "li",
            {
              key: i,
              staticClass: "room-attendance-mobile-item",
              class: { isOpen: _vm.openUserList.includes(i) },
            },
            [
              _c(
                "div",
                {
                  staticClass: "room-attendance-mobile-item-header",
                  on: {
                    click: function ($event) {
                      return _vm.toggleUserInfo(i)
                    },
                  },
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "room-attendance-mobile-item-title",
                      class: { me: attendance.userId === _vm.me.userId },
                    },
                    [_vm._v(_vm._s(attendance.nickname || attendance.username))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "room-attendance-mobile-item-button-container",
                    },
                    [
                      attendance.present
                        ? _c("div", {
                            staticClass:
                              "room-attendance-mobile-item-button join-status",
                          })
                        : _vm._e(),
                      _c("button", {
                        staticClass:
                          "room-attendance-mobile-item-button toggle-switch",
                      }),
                    ]
                  ),
                ]
              ),
              _c("div", { staticClass: "room-attendance-mobile-item-body" }, [
                _c(
                  "div",
                  { staticClass: "room-attendance-mobile-item-body-item" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("attendance.list.init")))]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-value",
                      },
                      [_vm._v(_vm._s(_vm.getFormedDate(attendance.firstEnter)))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "room-attendance-mobile-item-body-item" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("attendance.list.last")))]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-value",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            !attendance.lastLeave
                              ? "-"
                              : _vm.getFormedDate(attendance.lastLeave)
                          )
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "room-attendance-mobile-item-body-item" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("attendance.list.total")))]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-value",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.getDurationDate(
                              attendance.totalAttendingSeconds
                            )
                          )
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "room-attendance-mobile-item-body-item" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("attendance.list.kickCount")))]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-value",
                      },
                      [_vm._v(_vm._s(attendance.kickCount))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "room-attendance-mobile-item-body-item" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-title",
                      },
                      [_vm._v("Email")]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "room-attendance-mobile-item-body-item-value",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            attendance.email ||
                              _vm.$t("attendance.modal.nonMember")
                          )
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }